
import { defineComponent } from "vue";
import ForSale from "@/components/AllMoonHeads.vue";
import { useMeta } from "vue-meta";

export default defineComponent({
  name: "Sets",
  setup() {
    useMeta({
      title: "All MoonHeads",
      description: "View all the MoonHeads from each set.",
      htmlAttrs: { lang: "en", amp: true },
    });
  },
  components: {
    ForSale,
  },
});
